const dashboardHome = {
  activeProjects: "Active Projects",
  documents: "Documents",
  avgHealth: "Avg Health",
  todayEvents: "Today's Events",
  recentProjects: "Recent Projects",
  viewAll: "View All",
  noProjects: "No projects yet",
  noEvents: "No events today",
  quickActions: "Quick Actions",
  newProject: "New Project",
  newDocument: "New Document",
  storyMap: "vStory",
  loadError: "Error loading data",
  retry: "Retry",
  entityTypes: "Entities",
  recentEntities: "Recent Entities",
  noEntities: "No entities yet",
  items: "items",
  docPipeline: "Document Pipeline",
  docDrafts: "Drafts",
  docPending: "Pending Signature",
  docSigned: "Signed",
  docExpiring: "Expiring Soon",
} as const;
export default dashboardHome;
